import { FC } from 'react';
import { Typography } from '@mui/material';
import { TAmountAndCurrencyProps } from './types';

export const AmountAndCurrency: FC<TAmountAndCurrencyProps> = ({
	amount,
	currency,
	size = 0.875,
	color = 'auto',
	bold = false,
	type = 'ISO',
	afterPoint = 2,
}) => {
	const amountArray = amount?.toFixed(afterPoint).split('.');
	return (
		<Typography component="span" sx={{ m: 0, p: 0 }}>
			<Typography
				component="span"
				color={color}
				sx={{ m: 0, p: 0, fontSize: `${size}rem`, fontWeight: bold ? 'bold' : 'normal' }}
			>
				{type === 'symbol' ? (
					<span
						style={{
							fontFamily: 'Arial',
						}}
					>
						{
							new Intl.NumberFormat('en-EN', { style: 'currency', currency }).format(
								+amountArray?.[0],
							)[0]
						}
					</span>
				) : (
					''
				)}
				{new Intl.NumberFormat('en').format(+amountArray?.[0])}
				{afterPoint > 0 && '.'}
				<Typography
					component="span"
					sx={{
						fontSize: afterPoint === 2 ? `${size * 0.7}rem` : `${size}rem`,
						// color,
						// opacity: 0.8,
						fontWeight: bold ? '900' : 'normal',
					}}
				>
					{amountArray?.[1]}
				</Typography>
			</Typography>
			{type === 'ISO' && (
				<>
					&nbsp;
					<Typography
						component="span"
						color={color}
						sx={{
							fontSize: `${size * 0.7}rem`,
							// color,
							opacity: 0.7,
							fontWeight: bold ? 'bold' : 'normal',
						}}
					>
						{currency}
					</Typography>
				</>
			)}
		</Typography>
	);
};
